import React, { FC } from 'react'
import { Flex } from '../Flex/flex.component'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Typography } from '@mui/material';

interface IPlaceholderProps {
    description: string
    sx?: object
    Bottom?: () => JSX.Element
    textStyle?: object
}

const Placeholder : FC<IPlaceholderProps> = ({ description, Bottom, textStyle, ...rest}) => {
    return(
        <Flex flexDirection='column' alignItems='center' justifyContent='center' flex={1} {...rest}>
            <ErrorOutlineIcon fontSize='large' />
            <Typography marginTop='15px' sx={textStyle} >{description}</Typography>

            {Bottom && <Bottom />}
        </Flex>
    )
}

export { Placeholder}